import { EnvironmentScope, ProvisioningContext } from "../provisioning-context.model";

/** Keep template definitions available while navigating; strip them only from submitted requests. */
export function sanitizeExistingResourceContext(
	context: ProvisioningContext,
	{ preserveTemplateSettings = false }: { preserveTemplateSettings?: boolean } = {}
): ProvisioningContext {
	const isExistingScope =
		context.provisioningScope === EnvironmentScope.ExistingSiteCollection || context.provisioningScope === EnvironmentScope.ExistingTeam;

	if (!isExistingScope) {
		return context;
	}

	return {
		...context,
		products: preserveTemplateSettings ? context.products : context.products.map(product => ({
			...product,
			catalogProduct: {
				...product.catalogProduct,
				details: {
					...product.catalogProduct.details,
					policies: undefined,
					resourceBranding: undefined,
					classification: undefined,
					storage: undefined,
					hubSiteAssociation: undefined,
				},
				associatedUserProduct: product.catalogProduct.associatedUserProduct ? {
					...product.catalogProduct.associatedUserProduct,
					templatePolicies: undefined,
					templateGovernance: {
						...product.catalogProduct.associatedUserProduct.templateGovernance,
						policies: [],
						resourceBranding: undefined,
						hubSiteAssociation: null,
					} as typeof product.catalogProduct.associatedUserProduct.templateGovernance
				} : undefined
			}
		})),
		governance: {
			...context.governance,
			hubSiteAssociation: undefined,
			inheritHubBranding: false,
			brandCenterPaletteId: undefined,
			brandCenterPaletteName: undefined,
			brandCenterPaletteColors: [],
			bindTuningThemeId: undefined,
			bindTuningThemeName: undefined,
			sharePointSiteLimit: null,
			siteLogo: null,
			siteLogoThumbnail: null,
			teamLogo: null,
			isToReuseLogo: null,
			members: [],
			owners: [],
			sensitivityLabel: null,
			retentionLabelType: 'template',
			listsRetentionLabels: [],
		},
		resourcesDetails: context.resourcesDetails.map(resource => ({
			...resource,
			privacy: undefined,
		})),
		selectiveProvisioning: context.selectiveProvisioning
			? {
				...context.selectiveProvisioning,
				office365: context.selectiveProvisioning.office365
					? {
						...context.selectiveProvisioning.office365,
						provisioningTemplate: context.selectiveProvisioning.office365.provisioningTemplate
							? {
								...context.selectiveProvisioning.office365.provisioningTemplate,
								webSettings: context.selectiveProvisioning.office365.provisioningTemplate.webSettings
									? {
										...context.selectiveProvisioning.office365.provisioningTemplate.webSettings,
										welcomePage: undefined,
									}
									: context.selectiveProvisioning.office365.provisioningTemplate.webSettings,
							}
							: context.selectiveProvisioning.office365.provisioningTemplate,
					}
					: context.selectiveProvisioning.office365,
			}
			: context.selectiveProvisioning,
	};
}